export default () => ({
  list: {
    data: []
  },
  userStatus: {
    0: '一般',
    1: 'テスト用'
  }
})
